import React, { useEffect, useState } from 'react'
import { OnboardSelect } from '../../../../components/Onboard/OnboardComponents/Dropdown/Select';
import Filter_Icon from './../../../../assets/images/Filter_Icon.png';
import AdminBreadcrumb from '../../../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountEvaluatorAccountsData, getAccountEvaluatorEvaluatorsData, getAccountEvaluatorTableData, getAccountEvaluatorUsersData, updateAccountEvaluatorMappingDataStart, updateNewEvaluatorDataStart } from '../../../../actions/Applications/aquaa.action';
import { AssignedAccountsTblPopUp } from '../../../../components/TeamLeaderView/AgentsKPIModels/AgentsKPIModels';
import { TimeOutSelect } from '../../../../components/Onboard/OnboardComponents/Dropdown/TimeOutSelect';
import RefreshIcon from './../../../../assets/images/Reset_Icon.png';

const AccountEvaluatorMapping = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const accountEvaluatorAccounts = useSelector((state) => state.aquaaReducer.accountEvaluatorAccounts);
  const accountEvaluatorEvaluators = useSelector((state) => state.aquaaReducer.accountEvaluatorEvaluators);
  const accountEvaluatorTableData = useSelector((state) => state.aquaaReducer.accountEvaluatorTableData);
  const accountEvaluatorUsersData = useSelector((state) => state.aquaaReducer.accountEvaluatorUsersData);
   const RoleId = localStorage.getItem('Role_id');


  const [isRefreshClicked, setIsRefreshClicked] = useState(false);
  const [formData, setFormData] = useState([]);
  const [model, setModel] = useState(false);
  const [validation, setValidation] = useState('')

  console.log('accountEvaluatorUsersData', accountEvaluatorUsersData)
  useEffect(() => {
    dispatch(getAccountEvaluatorAccountsData(RoleId));
    dispatch(getAccountEvaluatorEvaluatorsData(RoleId));
  }, [dispatch,RoleId])

  useEffect(() => {
    if (formData.account || formData.evaluatorEmail)
      dispatch(getAccountEvaluatorTableData(formData.account?.accountID ? formData.account?.accountID : '', formData.evaluatorEmail?.evaluatorID ? formData.evaluatorEmail?.evaluatorID : '', RoleId))
  }, [dispatch, formData.account, formData.evaluatorEmail,RoleId])

  const tableHeaders = accountEvaluatorTableData.length > 0
    ? Object.keys(accountEvaluatorTableData[0])
    : [];

  const addValueToFormData = (name, selectedOption) => {
    if (name !== 'Select') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: selectedOption,
      }));
    }
  };

  const QueryHandler = query => {
    setTimeout(() => {
      dispatch(getAccountEvaluatorUsersData(query));
    }, 2000)
    if (query === '') {
      dispatch(getAccountEvaluatorUsersData(''));
    }
  }

  // const HandleAddUser = (event) => {
  //       event.preventDefault();
  //       const fieldName = event.target.getAttribute('name');
  //       const fieldValue = event.target.value;
  //       if (fieldValue !== 'Select') {
  //           const newFormData = { ...formData };
  //           newFormData[fieldName] = fieldValue;
  //           setFormData(newFormData)
  //       }
  //   }

  const AddMappingHandler = () => {
    const { account, evaluatorEmail } = formData;
    // Check if both account and evaluator are selected
    if (!account || !evaluatorEmail) {
      setValidation('Please select both account and evaluator.');
      return;
    }

    // Search for a match in accountEvaluatorTableData
    const existingEntry = accountEvaluatorTableData.find(
      (row) =>
        row.accountID === account.accountID &&
        row.evaluatorID === evaluatorEmail.evaluatorID
    );

    if (existingEntry) {
      // If entry exists, show error
      setValidation('This account-evaluator combination already exists!');
    } else {
      // If no entry exists, show success
      dispatch(updateAccountEvaluatorMappingDataStart([{ "EvaluatorID": evaluatorEmail?.evaluatorID, "AccountID": account?.accountID }],
        () => {
          setValidation('');
          dispatch(getAccountEvaluatorTableData(formData.account?.accountID ? formData.account?.accountID : '', formData.evaluatorEmail?.evaluatorID ? formData.evaluatorEmail?.evaluatorID : '', RoleId))
        }
      ))
    }
  };

  const ModelSubmitHandler = () => {
    dispatch(updateNewEvaluatorDataStart(
      [{ Email: formData.email?.email, Name: formData.email?.name }],
      () => {
        setModel(false);
        dispatch(getAccountEvaluatorEvaluatorsData(RoleId));
      }
    ));
  };

  const resetHandler = () =>{
     setFormData({});   
  setIsRefreshClicked(true);
  dispatch(getAccountEvaluatorTableData('', '', RoleId))


  }


  console.log('formData', formData, formData.email?.email, formData.email?.name)
  return (
    <div>
      <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' value3={() => history.push('/aquaaadminonboardlanding')} isActive3={true} label3='AQuAA Admin' isActive4={false} label4='Account Evaluator Mapping' />

      <section className='App_Layout'>
        <main className='Title_bar'> <div className='Applications_Title'> Account Evaluator Mapping </div>
          <div className='btn_adduser' style={{ width: '230px' }} onClick={() => setModel(true)}>Add New Evaluator</div></main>
      </section>
      <div>{validation}</div>
      <section className='Filter_aquaa'>
        <main className='aquaa_filter_img'>
          <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '30px', paddingLeft: '30px' }} />
        </main>
        <div className='aquaaFilterAlignment'>
          <main className='Aquaa_dropdown' style={{ width: 300 }}>
            <label HtmlFor='country'>Account</label>
            <OnboardSelect data={accountEvaluatorAccounts} name='account' value='account' id='accountID'
              editValue='' addValueToQueue={(key, value) => {
    addValueToFormData(key, value);
    setIsRefreshClicked(false);
  }} refresh={isRefreshClicked} passFullObject={true} />
          </main>
          <main className='Aquaa_dropdown' style={{ width: 300 }}>
            <label HtmlFor='username'>Evaluator</label>
            <OnboardSelect data={accountEvaluatorEvaluators} name='evaluatorEmail' value='evaluatorEmail' id='evaluatorID'
              editValue='' addValueToQueue={(key, value) => {
    addValueToFormData(key, value);
    setIsRefreshClicked(false);
  }} refresh={isRefreshClicked} passFullObject={true} />
          </main>
          <button className='btn_adduser' style={{ width: '160px' }} onClick={() => AddMappingHandler()}>Add Mapping</button>

          <div style={{alignSelf:'center'}} onClick={resetHandler}><img src={RefreshIcon} alt='' width='30px'/></div>
        </div>
      </section>

      <section style={{ marginTop: '20px' }}>
        <div className="aquaa-table-container">
          <table className="aquaa-table">
            <thead>
              <tr>
                {tableHeaders.map((col, index) => (
                  <th key={index}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {accountEvaluatorTableData && accountEvaluatorTableData.length > 0 ? (
                accountEvaluatorTableData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {tableHeaders.map((col, colIndex) => {
                      const cellData = row[col]; // Get the data for this column in the current row

                      if (col === 'EvaluationDate') {
                        return <td key={colIndex}>{new Date(cellData).toLocaleDateString()}</td>; // Format date
                      }



                      return (
                        <td key={colIndex} style={col === 'EvaluationID' ? { cursor: 'pointer', color: '#004aac' } : null}>
                          {(cellData)}
                        </td>
                      );
                    })}

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length + 1}>
                    <section>
                      <div className="noData-para" style={{ marginTop: 0 }}>
                        <div style={{ marginTop: 30 }}>
                          No data available, please try different filters or contact the admin.
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {model &&
        <AssignedAccountsTblPopUp isOpen={model} setShowModal={setModel}>
          <section>

            <main className='Aquaa_dropdown' style={{ width: 300 }}>
              <label HtmlFor='country'>Evaluators</label>
              <TimeOutSelect data={accountEvaluatorUsersData} name='email' value='email' id='id'
                QueryHandler={QueryHandler} passFullObject={true}
                editValue=''
                addValueToQueue={addValueToFormData} />
            </main>


          </section>
          <main style={{ display: 'flex', justifyContent: 'center' }}>   <div className='btn_adduser' onClick={() => ModelSubmitHandler()}>Submit</div>
            <div className='btn_canceluser' onClick={() => setModel(false)}>Cancel</div></main>

        </AssignedAccountsTblPopUp>
      }
    </div>
  )
}

export default AccountEvaluatorMapping
